import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ConfettiComponent } from './components/confetti/confetti.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SplashComponent } from './components/splash/splash.component';

import { BaseComponent } from './base/base.component';
import { CustomSnackbarComponent } from './components/custom-snackbar/custom-snackbar.component';
import { CurrencyPipe } from './pipes/currency.pipe';
import { DatePipe } from './pipes/date.pipe';
import { DateTimePipe } from './pipes/datetime.pipe';
import { PercentagePipe } from './pipes/percentage.pipe';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { SkeletonComponent } from './components/skeleton/skeleton.component';

import { AccordionComponent } from './components/accordion/accordion.component';
import { ExpansionPanelComponent } from './components/expansion-panel/expansion-panel.component';
import { CardSlideComponent } from './components/slide/card-slide.component';

import { BaseHomeComponent } from './base-home/base-home.component';
import { Auth10tixLogoComponent } from './components/auth10tix-logo/auth10tix-logo.component';
import { CardsComponent } from './components/cards/cards.component';
import { FooterBaseHomeComponent } from './components/footer-base-home/footer-base-home.component';
import { FooterBaseComponent } from './components/footer-base/footer-base.component';
import { GoBackComponent } from './components/go-back/go-back.component';
import { HeaderComponent } from './components/header/header.component';
import { IconComponent } from './components/icon/icon.component';
import { KillPurchaseComponent } from './components/kill-purchase/kill-purchase.component';
import { ModalComponent } from './components/modal/modal.component';
import { ScoreLoadingComponent } from './components/score-loading/score-loading.component';
import { DecimalsPipe } from './pipes/decimals.pipe';
import { PrivateNumberPipe } from './pipes/private-number.pipe';
import { TimerPipe } from './pipes/timer.pipe';

import { PaymentComponent } from './components/payment/payment.component';
import { StepByStepComponent } from './components/step-by-step/step-by-step.component';
import { SummaryComponent } from './components/summary/summary.component';
import { ToggleMenuMobileComponent } from './components/toggle-menu-mobile/toggle-menu-mobile.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { DayNamePipe } from './pipes/day-name.pipe';
import { CleanCardBrandPipe } from './pipes/clean-card-brand.pipe';
import { PowerpayCurrencyPipe } from './pipes/powerpay-currency.pipe';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { WarningBoxComponent } from './components/warning-box/warning-box.component';

const PIPES = [
  TimerPipe,
  PercentagePipe,
  CurrencyPipe,
  DatePipe,
  DateTimePipe,
  PrivateNumberPipe,
  DecimalsPipe,
  DayNamePipe,
  CleanCardBrandPipe,
  PowerpayCurrencyPipe,
];

const COMPONENTS = [
  CardsComponent,
  CustomSnackbarComponent,
  ConfettiComponent,
  SplashComponent,
  NavbarComponent,
  FooterComponent,
  FooterBaseComponent,
  CustomSnackbarComponent,
  SkeletonComponent,
  CardSlideComponent,
  AccordionComponent,
  ExpansionPanelComponent,
  SplashComponent,
  BaseComponent,
  KillPurchaseComponent,
  HeaderComponent,
  GoBackComponent,
  Auth10tixLogoComponent,
  ScoreLoadingComponent,
  BaseHomeComponent,
  FooterBaseHomeComponent,
  ModalComponent,
  IconComponent,
  TooltipDirective,
  PaymentComponent,
  SummaryComponent,
  StepByStepComponent,
  ToggleMenuMobileComponent,
  TooltipComponent,
  WarningBoxComponent,
];

@NgModule({
  declarations: [...COMPONENTS, ...PIPES],
  imports: [
    CommonModule,
    RouterModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTabsModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [...COMPONENTS, ...PIPES],
})
export class MOLayoutModule {}
